import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {Fab, Tooltip} from '@mui/material';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';

export default function SectionSwitchFab() {
    const location = useLocation();
    const navigate = useNavigate();

    const isOnIdea = location.pathname.startsWith('/idea');
    const isOnChat = location.pathname.startsWith('/chat');

    if (!isOnIdea && !isOnChat) return null;

    const target = isOnIdea ? '/chat' : '/idea';
    const tooltip = isOnIdea ? '기존 챗봇으로 이동' : '창의혁신아이디어로 이동';
    const Icon = isOnIdea ? ChatBubbleOutlineRoundedIcon : LightbulbOutlinedIcon;

    return (
        <Tooltip title={tooltip} placement='left'>
            <Fab
                color='primary'
                onClick={() => navigate(target)}
                sx={{
                    position: 'fixed',
                    bottom: 24,
                    right: 24,
                    zIndex: 1200,
                    boxShadow: '0 6px 18px rgba(130, 93, 252, 0.32)'
                }}
            >
                <Icon />
            </Fab>
        </Tooltip>
    );
}
